import validate from "validate.js";
import { mergeRight, omit } from "ramda";

export const firstError = (errors, field) =>
  errors[field] ? errors[field][0] : "";

export const validateField = (constraints, field, value, errors) => {
  const results = validate.single(value, constraints[field]);

  return results
    ? mergeRight(errors, { [field]: results })
    : omit([field], errors);
};

export const validateObject = (constraints, obj) => validate(obj, constraints);
